import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface TagConfirmationCardProps {
  is_public?: boolean;
  name?: string;
}

export const TagConfirmationCard = ({
  name,
  is_public,
}: TagConfirmationCardProps) => {
  let publicText: string | undefined;
  if (is_public !== undefined) {
    publicText = is_public
      ? t("help_widget.copilot.confirmation_card.yes")
      : t("help_widget.copilot.confirmation_card.no");
  }

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.tag_title")}
      attributes={[
        {
          label: t("help_widget.copilot.confirmation_card.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.confirmation_card.public"),
          value: publicText,
        },
      ]}
    />
  );
};
